var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-conversation-answer-emojiimage",class:_vm.className,on:{"click":_vm.Handle_OnClick}},[_c('img',{attrs:{"height":"110","src":_vm.$asset('image/emoji/' + _vm.multipleChoiceModel.shortText + '.png')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }